import { useEffect } from "react";

/**
 * Prevents accidental navigation away when the user has unsaved work.
 * Uses beforeunload for browser back/refresh/tab close.
 */
export function useNavigationGuard(shouldBlock: boolean) {
  useEffect(() => {
    if (!shouldBlock) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "You have unsaved changes. Are you sure you want to leave?";
    };

    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [shouldBlock]);
}
